const PIP_HCRA_DICT = {
  in_patient: 'In Patient',
  out_patient: 'Out Patient',
  na: 'N/A',
} as const;

export default PIP_HCRA_DICT;
